import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../shared/base-classes/base.component';
import {
  StudentProfileResponseDto,
  UserTypeEnum
} from '@whetstoneeducation/hero-common';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AppPageHeaderService } from '../../../shared/page-header/page-header.service';
import { HeaderButtonAction } from '../../../shared/page-header/header-button';
import { AppBehaviorCodeEntryCreateModalComponent } from '../../behavior-code-entry/behavior-code-entry-create-modal/behavior-code-entry-create-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AppToastManagerService } from '../../../shared/services/toast-manager.service';
import { PrinterService } from '../../../shared/printer/printer.service';
import { browserPrintProfile } from 'src/app/shared/printer/browser-print.util';
import { AppStudentsService } from '../students.service';

@Component({
  selector: 'app-student-profile',
  templateUrl: './student-profile.template.html',
  styleUrls: ['./student-profile.scss']
})
export class AppStudentProfile extends BaseComponent implements OnInit {
  public pageHeaderSubscription: Subscription;

  public profile: StudentProfileResponseDto;
  public isStudent: boolean = false;
  public noStudent: boolean = false;
  public points = 0;
  public browserPrint: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private dialog: MatDialog,
    private pageHeaderService: AppPageHeaderService,
    private toastService: AppToastManagerService,
    private appStudentsService: AppStudentsService,
    private printerService: PrinterService
  ) {
    super();
  }

  ngOnInit(): void {
    this.profile = this.route.snapshot.data.data;
    if (!this.profile) {
      this.noStudent = true;
    } else {
      this.points = this.profile.profileData.reduce(
        (acc, data) => acc + +data.points,
        0
      );
    }
    this.isStudent = this.StorageManager.isUserType([
      UserTypeEnum.STUDENT,
      UserTypeEnum.GUARDIAN
    ]);
  }

  public async showTrackModal() {
    this.dialog.open(AppBehaviorCodeEntryCreateModalComponent, {
      width: '600px',
      panelClass: 'default-dialog',
      data: {
        studentIds: [this.profile.studentDetail.id]
      }
    });
  }

  private async printStudentInfo(): Promise<void> {

    if (this.printerService.usbAvailable) {
      try {
         const printStudentInfo = await this.appStudentsService.generateStudentInfoPrintData(
            this.printerService.configuration.languageType,
            this.profile.studentDetail
          );
          
          this.printerService.addToPrintQueue(printStudentInfo);

      } catch (error) {
        this.toastService.error('Error printing student info, printer not found');
      }
    } else if (!this.printerService.usbAllowed || this.browserPrint) {
      browserPrintProfile(this.profile.studentDetail);
    }
  }

  ngAfterViewInit(): void {
    this.pageHeaderSubscription =
      this.pageHeaderService.buttonAction$.subscribe(
        async (action: HeaderButtonAction) => {
          if (action === HeaderButtonAction.TRACK_STUDENTS) {
            await this.showTrackModal();
          }
          if (action === HeaderButtonAction.UPDATE) {
            await this.router.navigate([
              'students',
              this.profile.studentDetail.id
            ]);
          }
          if (action === HeaderButtonAction.PRINT_STUDENT_INFO) {
            const dialog = await this.printerService.initializeDevice();
            if (dialog) {
              dialog.afterClosed().subscribe((browserPrint) => {
                this.browserPrint = browserPrint;
                this.printStudentInfo();
              });
            } else {
              this.printStudentInfo();
            }
          }
        }
      );
  }

  public showError(): boolean {
    return this.isStudent && this.noStudent;
  }
}
